'use client';
import {cn} from '@/lib/utils';
import {StrapiContact} from '@/types/strapi';
import {useLocale} from 'next-intl';
import Link from 'next/link';
import {dummyImages} from '../helpers/utils';

export default function ContactList(prop: {
  moduleData: any;
  moduleOption: any;
}) {
  const locale = useLocale();
  const contactList = prop.moduleData || [];
  const sort = prop.moduleOption?.sort;
  if (sort) {
    contactList.sort((a: any, b: any) => {
      return sort.indexOf(a.slug) - sort.indexOf(b.slug);
    });
  }

  return (
    <div className="questrial text-[18px]">
      <div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4  mt-4">
          {contactList.map((result: StrapiContact, index: number) => (
            <div key={'contact_' + index} className="border border-gray-300 ">
              <div className="flex flex-col w-full ">
                <div className="md:flex md:flex-cols-2 gap-2 md:items-start">
                  <img
                    src={result.image?.url}
                    alt={result.title}
                    className={'w-full aspect-[16/9] object-cover'}
                  />
                </div>
                <div className="flex items-center justify-center w-full py-2">
                  <img
                    src={(
                      result.icon?.url ??
                      dummyImages[index % dummyImages.length].src
                    ).trim()}
                    alt={result.title}
                    className={'w-[170px] h-[50px] object-contain'}
                  />
                </div>
                <div className="px-2 bg-[#e31836] text-white text-lg font-bold flex items-center justify-center py-2">
                  {result.country}
                </div>
                <div className="px-2 flex items-center justify-center text-md">
                  <h2
                    className={cn(
                      ' text-[#e31836] my-4 overflow-hidden  ',
                      locale == 'en' ? 'font-[700]' : 'font-[500]'
                    )}
                  >
                    <div className="line-clamp-3 font-bold">{result.title}</div>
                  </h2>
                </div>
                <div className="px-4 text-sm flex flex-col gap-12 pb-10 text-[#333]">
                  {result.contact_info.map((contact_info, index) => {
                    return (
                      <div
                        key={'contact_info_' + index}
                        className="flex flex-col gap-2"
                      >
                        {contact_info.at && (
                          <div className="flex  items-start align-center justify-start  gap-2">
                            <span className="material-symbols outlined ">
                              location_on
                            </span>
                            <span
                              dangerouslySetInnerHTML={{
                                __html: contact_info.at
                              }}
                            ></span>
                          </div>
                        )}
                        {contact_info.phone && (
                          <div className="flex items-center justify-start  gap-2">
                            <span className="material-symbols outlined">
                              call
                            </span>
                            <Link
                              prefetch={false}
                              href={'tel:' + contact_info.phone}
                            >
                              {contact_info.phone}
                            </Link>
                          </div>
                        )}
                        {contact_info.fax && (
                          <div className="flex items-center justify-start  gap-2">
                            <span className="material-symbols outlined">
                              print
                            </span>
                            {contact_info.fax}
                          </div>
                        )}
                        {contact_info.email && (
                          <div className="flex items-center justify-start  gap-2">
                            <span className="material-symbols outlined">
                              email
                            </span>
                            <Link
                              prefetch={false}
                              href={'mailto:' + contact_info.email}
                            >
                              {contact_info.email}
                            </Link>
                          </div>
                        )}
                        {contact_info.html && (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: contact_info.html
                            }}
                          ></div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
